import { GoogleMap as GoogleMapStyled } from './styled';

const GoogleMap = () => (
  <GoogleMapStyled
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.347473842258!2d106.8164691147692!3d-6.217826195498961!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3fba19560d7%3A0xc7fa648c0764c955!2sStockbit!5e0!3m2!1sen!2sid!4v1640226301166!5m2!1sen!2sid"
    allowFullScreen
    loading="lazy"
    title="Stockbit on Map"
  />
);

export default GoogleMap;
